module.exports = __webpack_public_path__ + "2171def33673892541d594afb6605603.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/greetings/mambo.png
// module id = 3222
// module chunks = 0